import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';

// Components
import { GIButton } from 'app-components';



const UserDetails = (props) => {
    const { 
        userDetails,
        environment: {
            links: {
                LOGIN
            },
        }
    } = props;

    const navigateToResetPassword = () => {
        window.location.href = '/hix/account/user/forgotpassword'; 
    };

    const navigateToLogin = () => {
        window.location.href = LOGIN;
    };

    const getUserInfo = () => {
        return (
            <Fragment>
                <div className="gi-input grid-row gi-stackform margin-t-0">
                    <label className="gi-input__label padding-l-0">
                        <FormattedMessage id='anonymous.forgot_email.your.email.label' />
                    </label>

                    <label className="gi-input__input grid-col-12 text-left">
                        {userDetails.userName}
                    </label>
                </div>
                <div className="controls-container">
                    <GIButton  type='button' id='updateNewTicketCategory' labelId={'anonymous.forgot_email.button.resetPassword'} onClickHandler={navigateToResetPassword} />
                    <GIButton type='button'  id='updateNewTicketCategory' labelId={'anonymous.forgot_email.button.login'} onClickHandler={navigateToLogin}/>
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <form>
                { getUserInfo()}
            </form>
        </Fragment>
    );
};
export default UserDetails;